import {
    BulkUpdateDigitalWalletsRequest,
    DigitalWalletFilterRequest,
    DigitalWalletManagementFilterRequest,
    DigitalWalletManagementRowResult,
} from "@/models/digital.wallet";
import { TransactionFilterRequest } from "@/models/transaction";
import popupService from "@/services/popupService";
import { sleep } from "@/util";
import { makeAutoObservable } from "mobx";
import api from "../services/api";
const delay = sleep(400);

export class DigitalWalletStore {
    walletSelectionModel: Array<number> = [];
    updateWalletsAfterUpdate: boolean = false;
    digitalWalletsStore: Array<DigitalWalletManagementRowResult> = [];
    bulkUpdateDigitalWalletsRequest: BulkUpdateDigitalWalletsRequest = new BulkUpdateDigitalWalletsRequest();
    bulkFilterSelected: boolean = false;
    totalFilter: number = 0;
    totalCount: number = 0;
    currentSubsidyBalanceOfAllEmployees?: number = 0;
    currentBalanceInActiveWallets?: number = 0;
    unpaidSubsidies?: number = 0;
    subsidyBalance?: number = 0;
    subsidyUsedPercentNotification?: number = 0;

    constructor() {
        makeAutoObservable(this);
    }
    public getDigitalWallets = async (filter: DigitalWalletFilterRequest) => {
        popupService.showLoading();
        await delay;
        var response = await api.getDigitalWallets(filter);
        popupService.close();
        return response.data;
    };
    public getDigitalWalletsManagement = async (filter: DigitalWalletManagementFilterRequest) => {
        popupService.showLoading();
        await delay;
        var response = await api.getDigitalWalletsManagement(filter);
        popupService.close();
        return response.data;
    };
    public bulkUpdateDigitalWallets = async (filter: BulkUpdateDigitalWalletsRequest) => {
        popupService.showLoading();
        await delay;
        var response = await api.bulkUpdateDigitalWallets(filter);
        popupService.close();
        return response.data;
    };
    public getTransactions = async (filter: TransactionFilterRequest) => {
        popupService.showLoading();
        await delay;
        var response = await api.getTransactions(filter);
        popupService.close();
        return response.data;
    };
    public getAllTransactions = async (filter: TransactionFilterRequest) => {
        popupService.showLoading();
        await delay;
        var response = await api.getAllTransactions(filter);
        popupService.close();
        return response.data;
    };
    public searchDigitalWalletIds = async (filter: DigitalWalletManagementFilterRequest) => {
        popupService.showLoading();
        await delay;
        var response = await api.searchDigitalWalletIds(filter);
        popupService.close();
        return response.data;
    };
    public exportDigitalWallets = async (filter: DigitalWalletManagementFilterRequest) => {
        popupService.showLoading();
        await delay;
        var response = await api.exportDigitalWallets(filter);
        popupService.close();
        return response.data;
    };

    public setWalletSelectionModel(rows: number[]) {
        this.walletSelectionModel = rows;
    }

    public setBulkFilterSelected(val: boolean) {
        this.bulkFilterSelected = val;
    }

    public setUpdateWalletsAfterUpdate(value: boolean) {
        this.updateWalletsAfterUpdate = value;
    }

    public setDigitalWalletsStore(value: DigitalWalletManagementRowResult[]) {
        this.digitalWalletsStore = value;
    }

    public setBulkUpdateDigitalWalletsRequest(request: BulkUpdateDigitalWalletsRequest) {
        this.bulkUpdateDigitalWalletsRequest = request;
    }

    public setDigitalWalletSums(
        totalCount: number,
        totalFilter: number,
        currentSubsidyBalanceOfAllEmployees: number,
        currentBalanceInActiveWallets: number,
        unpaidSubsidies: number,
        subsidyBalance: number,
        subsidyUsedPercentNotification: number
    ) {
        this.totalCount = totalCount;
        this.totalFilter = totalFilter;
        this.currentSubsidyBalanceOfAllEmployees = currentSubsidyBalanceOfAllEmployees;
        this.currentBalanceInActiveWallets = currentBalanceInActiveWallets;
        this.unpaidSubsidies = unpaidSubsidies;
        this.subsidyBalance = subsidyBalance;
        this.subsidyUsedPercentNotification = subsidyUsedPercentNotification;
    }
}

const digitalWalletStore = new DigitalWalletStore();
export default digitalWalletStore;
